export const useLinks = createSharedComposable(() => {
  const isExternalLink = useMemoize((link?: MaybeRef<string | undefined>) => {
    return unref(link)?.startsWith("http");
  });

  return {
    isExternalLink,
  };
});
